var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepriciation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0b6462;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.722,21.4h2.111V7.6H8.722ZM12.944,26h2.111V3H12.944ZM4.5,16.8H6.611V12.2H4.5Zm12.667,4.6h2.111V7.6H17.167Zm4.222-9.2v4.6H23.5V12.2Z",
    transform: "translate(-4.5 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepriciation);
export default __webpack_public_path__ + "static/media/depriciation.3ca21fa831caf27899735e8651310bc6.svg";
export { ForwardRef as ReactComponent };